import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

/**
 * Inline, link-styled button: primary-colored text that underlines on hover, with no button
 * chrome (no padding, background, or min-width). Use for value-as-link patterns — e.g. a
 * partner/owner name inside a detail field, or a resource link in an activity log — where the
 * label should read as an inline hyperlink but the action is a click handler, not navigation.
 *
 * Font size is inherited from the surrounding text; add a utility class (e.g. `text-sm`) on the
 * host to override. An optional leading {@link icon} renders at the text size.
 */
@Component({
  selector: 'xemex-link-button',
  standalone: true,
  imports: [MatIconModule],
  styleUrl: './link-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button type="button">
      <mat-icon [style.display]="icon() ? null : 'none'">{{ icon() }}</mat-icon>
      <ng-content />
    </button>
  `,
})
export class LinkButtonComponent {
  icon = input<string>();
}
